export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ19.c19d77a9.mp3";